import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import FileHandlerService from "./fileHandler.service";


export const FileExportService = {
    Export,
    ExportWithTermination
};

async function Export(data: RequestInputOutputParamsModel, basePath: string, type: string) {
    let url = `${basePath}/ExportTo${type}/`;
    if (type == "Csv") type = "zip";
    return FileHandlerService.DownloadFile(basePath, url, data, type);
}

async function ExportWithTermination(data: RequestInputOutputParamsModel, basePath: string, type: string, termination: string, fileNameEnding: string = "", setnamefile: string = "") {
    let url = `${basePath}/ExportTo${type}${termination}/`;
    if (type == "Csv") type = "zip";
    return FileHandlerService.DownloadFileWithValidate(basePath, url, data, type, fileNameEnding,setnamefile);
}
